<div class="progress">
  <div [ngClass]="'progress-bar ' + className" [attr.role]="'progressbar'" [attr.aria-valuenow]="percent" [attr.aria-valuemin]="0" [attr.aria-valuemax]="100"
    [style.width]="percent + '%'">
    {{percent | number}}%
  </div>
</div>
